import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons/faMapMarkerAlt'
import PropTypes from 'prop-types'
import React from 'react'

import SimpleIcon from './SimpleIcon'

export const CityListItem = React.forwardRef(({ query, label, ...props }, ref) => {
  return (
    <mark
      ref={ref}
      {...props}
      className='city-list-item qa-loc-item'
    >
      <SimpleIcon icon={faMapMarkerAlt} className='mr-1' />
      {label.trim()}
    </mark>
  )
})

CityListItem.propTypes = {
  query: PropTypes.object,
  label: PropTypes.string.isRequired
}

export default CityListItem
